import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Bundling",
  "menu": "Guides",
  "route": "/guides/bundling",
  "description": "Learn how to import and bundle components-extra."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Bundling components-extra in your project`}</h1>
    <h2>{`Optimizing bundle size`}</h2>
    <p><strong parentName="p">{`components-extra`}</strong>{` is tree-shakeable, meaning that you can import its components as named imports, like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BackToTop } from 'components-extra'
`}</code></pre>
    <p>{`If your bundler is set up to use the tree-shakeable libraries, it will automatically `}<strong parentName="p">{`only add the named imports
you used`}</strong>{`. In this example, only the `}<inlineCode parentName="p">{`<BackToTop>`}</inlineCode>{` button will be included in your bundle.`}</p>
    <p>{`Else, if your bundler is not set up to do tree-shaking, you can still only include the components you need
by importing them as defaults like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import BackToTop from 'components-extra/components/BackToTop'
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` you will need a transpiler like `}<a parentName="p" {...{
          "href": "https://babeljs.io/"
        }}>{`babel`}</a>{` to make the JS work in the browser. (Even if es6 is coming soon to moder broswers).
Some projects templates (like `}<a parentName="p" {...{
          "href": "https://github.com/facebook/create-react-app"
        }}>{`create-react-app`}</a>{`) handle this for you by default.`}</p>
    </blockquote>
    <h2>{`es5`}</h2>
    <p>{`If your project is not set up to transpile the `}<strong parentName="p">{`esm/es`}</strong>{` builds, you can still use the `}<strong parentName="p">{`cjs`}</strong>{`, written in es5:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const BackToTop = require("components-extra").BackToTop
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` you can also set up aliases in your project to alias `}<inlineCode parentName="p">{`components-extra/components`}</inlineCode>{` to `}<inlineCode parentName="p">{`components-extra`}</inlineCode>{` if you want imports to
look like `}<inlineCode parentName="p">{`import BackToTop from 'components-extra/BackToTop'`}</inlineCode>{`. You can check out how to do this with `}<a parentName="p" {...{
          "href": "https://webpack.js.org/configuration/resolve/"
        }}>{`webpack`}</a>{`
and with `}<a parentName="p" {...{
          "href": "https://www.npmjs.com/package/babel-plugin-module-resolver"
        }}>{`babel`}</a>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      